import React from 'react';
import { Spinner } from 'react-bootstrap';

import { UploadProgress } from 'utils/hooks/file_viewer/useFileViewerTransfers';

import './index.scss';

export default function TransferStatus({ progress }: { progress: UploadProgress | null }) {
  if (!progress) return null;

  const percent = Math.round((progress.done / progress.total) * 100);
  return (
    <div className="file-explorer-transfer" role="status">
      <Spinner animation="border" size="sm" role="presentation" />
      <span className="file-explorer-transfer-text">
        {progress.total > 1 ? `Enviando ${progress.done + 1} de ${progress.total}: ` : 'Enviando '}
        <b>{progress.current}</b>
      </span>
      {progress.total > 1 && (
        <span className="file-explorer-transfer-track" aria-hidden="true">
          <span className="file-explorer-transfer-fill" style={{ width: `${percent}%` }} />
        </span>
      )}
    </div>
  );
}
